// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification-module__notification--jjqmj","success":"Notification-module__success--2zfsT","error":"Notification-module__error--inxeh"};